import type { Query, QueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-keys';

const DETAIL_ROOTS = [
  queryKeys.orders.detailRoot(),
  queryKeys.orders.travelEsimDetailRoot(),
];

function isDetail(query: Query): boolean {
  return DETAIL_ROOTS.some((root) =>
    root.every((part, index) => query.queryKey[index] === part),
  );
}

/**
 * Deleting an order or an international eSIM touches both: every order
 * view, the eSIM listings (organization and line) and the beneficiary
 * lookup offered at checkout. Detail pages are only marked stale, not
 * refetched: the deleted record's page, still mounted until the redirect,
 * would get a 404.
 */
export function invalidateOrderAndTravelEsimViews(queryClient: QueryClient) {
  queryClient.invalidateQueries({
    queryKey: queryKeys.orders.root(),
    predicate: (query) => !isDetail(query),
  });
  queryClient.invalidateQueries({
    queryKey: queryKeys.orders.root(),
    predicate: isDetail,
    refetchType: 'none',
  });
  queryClient.invalidateQueries({ queryKey: queryKeys.lines.travelEsimsRoot() });
  queryClient.invalidateQueries({ queryKey: queryKeys.catalog.travelEsimLookupRoot() });
}
